import { useContextTS } from "@inrange/utils";
import { useKindeAuth } from "@kinde-oss/kinde-auth-react";
import { useQuery } from "@tanstack/react-query";
import { getUserOrgId } from "../getUserOrgId";
import getRelatedLandlordSitesList from "../http/getRelatedLandlordSitesList";
import { ReloginContext } from "../ReloginContext";
import { getAuthTokenBlocking } from "./utils";

const useRelatedLandlordSitesList = (
  orgId: string | undefined,
  siteId: string | undefined,
  userOrgIdParam?: string
) => {
  const { getToken, getClaim } = useKindeAuth();
  const { relogin } = useContextTS(ReloginContext);

  const fetchRelatedLandlordSitesList = useQuery(
    ["relatedLandlordSitesList", orgId, siteId],
    async () => {
      return getRelatedLandlordSitesList(
        await getAuthTokenBlocking(getToken, relogin),
        orgId!,
        siteId!,
        await getUserOrgId(getClaim, userOrgIdParam)
      );
    },
    { enabled: !!orgId && !!siteId }
  );

  return {
    fetchRelatedLandlordSitesList,
  };
};

export default useRelatedLandlordSitesList;
